module.exports = __webpack_public_path__ + "img/per2.e942dc61.png";